import type {
    SpecialtyCreateForm,
    SpecialtyUpdateForm,
    SpecialtyStatusUpdateForm,
    SpecialtyData,
    SpecialtyListItemData,
    ServiceBindingForm,
    SpecialtyResponse,
    SpecialtyListResponse,
} from 'chaika-frontend-types/frontend-cms';
import { Locale } from 'chaika-enums';

import { axios } from '@lib/axios';

const BASE_URL = '/api/specialty';

export class SpecialtyApi {
    public static async create(specialty: SpecialtyCreateForm): Promise<void> {
        await axios.post(BASE_URL, { specialty });
    }

    public static async update(id: string, specialty: SpecialtyUpdateForm): Promise<void> {
        await axios.put(`${BASE_URL}/${id}`, { specialty });
    }

    public static async updateStatus(id: string, specialty: SpecialtyStatusUpdateForm): Promise<void> {
        await axios.put(`${BASE_URL}/${id}/status`, { specialty });
    }

    public static async get(id: string): Promise<SpecialtyData> {
        const res = await axios.get<SpecialtyResponse>(`${BASE_URL}/${id}`);

        return res.data.specialty;
    }

    public static async getList(locale?: Locale): Promise<SpecialtyListItemData[]> {
        const res = await axios.get<SpecialtyListResponse>(BASE_URL, { params: { locale } });

        return res.data.specialties;
    }

    public static async bindService(id: string, specialty: ServiceBindingForm): Promise<void> {
        await axios.post(`${BASE_URL}/${id}/service`, { specialty });
    }

    public static async unbindService(id: string, serviceId: string): Promise<void> {
        await axios.delete(`${BASE_URL}/${id}/service/${serviceId}`);
    }
}

export { BASE_URL as SPECIALTY_API_BASE_URL };
